import { useParams } from 'react-router-dom';
import PatientDocumentsV2 from '~/components/maud/patients/profile/tabs/patient-document-V2';

const DocumentsPage = () => {
  const { patientId } = useParams<{ patientId: string }>();
  return <PatientDocumentsV2 patientId={patientId} />;
};

export default DocumentsPage;
